







































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import { ConversaoMedidasDTO, UnidadeMedidaProdutoDTO } from '@/interfaces/product';
import ProductChart from './product-chart.vue';

@Component({
  components: {
    ProductChart,
  },
})
export default class ProductSplitter extends BaseComponent {
  @Prop()
  public medidasEnteralDesc: ConversaoMedidasDTO;

  @Prop()
  public medidasEnteralSemDesc: ConversaoMedidasDTO;

  private getValorPrescrito(idUnidade: Number): string {
    let uni = this.getUnidade(this.medidasEnteralSemDesc, idUnidade);
    return this.decimalFormatHelper(uni.valor) + ' ' + uni.nome;
  }

  private getValorDescontado(idUnidade: Number): string {
    let uniSemDesc = this.getUnidade(this.medidasEnteralSemDesc, idUnidade);
    let uniComDesc = this.getUnidade(this.medidasEnteralDesc, idUnidade);
    let vSemDesc = Math.round(uniSemDesc.valor * 100) / 100;
    let vComDesc = Math.round(uniComDesc.valor * 100) / 100;
    return this.decimalFormatHelper(vSemDesc - vComDesc) + ' ' + uniSemDesc.nome;
  }

  private getValorResultado(idUnidade: Number): string {
    let uni = this.getUnidade(this.medidasEnteralDesc, idUnidade);
    return this.decimalFormatHelper(uni.valor) + ' ' + uni.nome;
  }

  private getUnidade(cm: ConversaoMedidasDTO, idUnidade: Number): UnidadeMedidaProdutoDTO {
    return cm.unidades.filter((u) => u.id == idUnidade)[0];
  }
}
